<template>
  <div id="upload">
    <v-container class="pa-0">
      <v-layout row wrap>
        <v-flex xs12>
          <div class="padding-15-no-bottom background-white">
            <h1 style="text-align: center;">{{ title }}</h1>
          </div>
          <v-card class="pa-0" flat color="#ffffff">
            <v-card-text>
              <div v-html="content"></div>
            </v-card-text>
          </v-card>
          <div v-if="!hasUploadError">
            <v-img height="35vh" class="make-photo" contain :src="imgUrl"></v-img>
          </div>
        </v-flex>
        <v-flex xs12>
          <div v-if="hasUploadError">
            <v-card class="pa-0" flat color="#ffffff">
              <v-card-text>
                <h2>Fout bij het versturen van de foto</h2>
                <div v-html="uploadError"></div>

                <br>
                <div style="text-align:center">
                <v-btn depressed dark color="#e32219" @click="$router.go()">Opnieuw</v-btn>
                </div>
              </v-card-text>
            </v-card>
          </div>
          <div v-if="!hasUploadError">
            <div class="text-xs-center">
              <v-btn dark fab large @click="$refs.file.click()" class="create-photo" v-show="!uploading" color="#2E4278">
                <v-icon dark>camera_alt</v-icon>
              </v-btn>
              <v-btn v-show="false" @click="$refs.fileNoCapture.click()">Upload</v-btn>
            </div>
            <input v-show="false" ref="file" type="file" @change="uploadFile('file')" accept="image/*" capture>
            <input v-show="false" ref="fileNoCapture" id="nocapture" type="file" @change="uploadFile('fileNoCapture')" accept="image/*">
          </div>
        </v-flex>
      </v-layout>
      <v-progress-linear
          v-show="uploading && !hasUploadError"
          indeterminate
          color="black"
      />
    </v-container>
    <v-footer ref="footer" fixed color="white" height="auto" class="background-white">
      <v-container class="pa-0 background-white" fluid style="padding-top: 6px; margin-top: 0px;">
        <v-layout row wrap>
          <v-flex xs12>
            <div class="v-btn--footer--direct_photo"><label for="nocapture">Kies een foto uit je bibliotheek</label>
            </div>
          </v-flex>
        </v-layout>
      </v-container>
    </v-footer>
  </div>
</template>

<script>

  import BackendService from "@/services/BackendService";

  export default {
    name: 'upload',
    data() {
      return {
        title: '',
        content: '',
        imgUrl: '/img/photo-explainer-003.png',
        file: null,
        uploading: false,
        hasUploadError: false,
        uploadError: ''
      }
    },
    mounted() {
      this.resetLocalStorage();
    },
    created() {
      this.getText();
    },
    methods: {
      getText() {
        BackendService.getText(14)
          .then((response) => {
            this.title = response.data.title;
            this.content = response.data.content;
          })
      },
      resetLocalStorage() {
        localStorage.removeItem('lastOrderCode');
        localStorage.removeItem('orderPlaced');
        localStorage.removeItem('photoKey');
        localStorage.removeItem('photoOptions');
        localStorage.removeItem('accessToken');
      },
      uploadFile(ref) {
        this.file = this.$refs[ref].files[0];
        let data = new FormData();
        data.append('file', this.file);

        this.uploading = true;

        BackendService.createPhoto(data)
          .then((response) => {
            localStorage.photoKey = response.data.key;
            localStorage.accessToken = response.data.token;
            this.uploading = false;
            this.$router.push('/check-photo')
          })
          .catch((error) => {
            this.hasUploadError = true;
            if (error.response) {
              let msg = '';
              error.response.data.forEach(function(elem) {
                if (elem.message) {
                  msg = msg + '<br>' + elem.message;
                }
              });
              this.uploadError = msg;
            }
          });
      },
    },
  };
</script>

<style scoped>
  .make-photo {
    margin-bottom: 15px !important;
  }

  .create-photo {
    -webkit-box-shadow: none !important;
    box-shadow: none !important;
  }
</style>
